module.exports = __webpack_public_path__ + "static/media/success.ad3d425c.png";